/*
  Cart UI sync layer (runs at module load, before DOMContentLoaded).

  Background: the theme's product-form.js no longer intercepts the
  add-to-cart form submit (Rebuy Smart Cart owns /cart/add.js now).
  Without our previous interceptor, three theme-side side effects
  stopped happening:
    1. Header cart-count-bubble never refreshed after a cart change.
    2. The PDP "Add to cart" button never showed its loading state.
    3. PUB_SUB_EVENTS.cartUpdate was never published, so listeners
       (e.g. product-info.js quantity rules) never refreshed.

  This module restores all three by watching for /cart/add|change|
  update|clear fetches at the fetch wrapper level, regardless of who
  initiated them (Smart Cart, Rebuy upsells, custom code).
*/
(function () {
  if (window.__cartUiSyncInstalled) return;
  window.__cartUiSyncInstalled = true;

  var pendingAtcButtons = new Set();

  function cartChangeUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1
    );
  }

  function clearAtcLoadingState(btn) {
    if (!btn) return;
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('loading');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.add('hidden');
    pendingAtcButtons.delete(btn);
  }

  function clearAllAtcLoadingStates() {
    pendingAtcButtons.forEach(clearAtcLoadingState);
  }

  function refreshCartBadge() {
    return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var itemCount = (cart && cart.item_count) || 0;
        var icons = document.querySelectorAll('#cart-icon-bubble, .nav-bar__cart-open-btn');
        icons.forEach(function (icon) {
          var bubble = icon.querySelector('.cart-count-bubble');
          if (itemCount === 0) {
            if (bubble) bubble.remove();
            return;
          }
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            icon.appendChild(bubble);
          }
          bubble.innerHTML =
            (itemCount < 100 ? '<span aria-hidden="true">' + itemCount + '</span>' : '') +
            '<span class="visually-hidden">' + itemCount + ' item' + (itemCount === 1 ? '' : 's') + '</span>';
        });

        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-ui-sync', cartData: cart });
          }
        } catch (e) {}

        return cart;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"][name="add"], .product-form__submit, .quick-add__submit');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    pendingAtcButtons.add(btn);
    setTimeout(function () { clearAtcLoadingState(btn); }, 5000);
  }, true);

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCart = cartChangeUrl(url);
    var result = origFetch.apply(this, arguments);
    if (isCart) {
      result
        .then(function () {
          clearAllAtcLoadingStates();
          refreshCartBadge();
        })
        .catch(function () {
          clearAllAtcLoadingStates();
        });
    }
    return result;
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  const openNavBtn = document.querySelector('#openNav');
  const closeNavBtn = document.querySelector('#closeNav');
  const navContainer = document.querySelector('.nav-drawer__wrapper');

  const openCartBtns = document.querySelectorAll('.nav-bar__cart-open-btn');

  function unlockBodyScrollIfNothingOpen() {
    const navOpen = document.querySelector('.nav-drawer__wrapper.open');
    if (navOpen) return;
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden', 'no-scroll');
  }

  function openCart(trigger) {
    /*
      Site uses Rebuy Smart Cart as the primary cart UI. Prefer Rebuy;
      fall back to Dawn's <cart-drawer> only if Rebuy is unavailable
      (e.g., third-party blocked). If neither is available the cart
      icon falls through to its <a href="/cart"> default navigation.

      Build a Routine keeps Appstle's builder cart, so skip Rebuy there.
    */
    var hideRebuyCart = document.body.classList.contains('tb-hide-rebuy-cart');
    if (
      !hideRebuyCart &&
      window.Rebuy &&
      Rebuy.SmartCart &&
      typeof Rebuy.SmartCart.show === 'function'
    ) {
      try {
        Rebuy.SmartCart.show();
        return true;
      } catch (e) {
        console.warn('Rebuy Smart Cart show() error:', e);
      }
    }

    const dawnCart = document.querySelector('cart-drawer');
    if (dawnCart && typeof dawnCart.open === 'function') {
      dawnCart.open(trigger);
      return true;
    }

    return false;
  }

  function bindCartButtons() {
    openCartBtns.forEach((btn) => {
      if (btn.dataset.cartBound === 'true') return;
      btn.dataset.cartBound = 'true';

      btn.addEventListener('click', (e) => {
        if (openCart(btn)) {
          e.preventDefault();
        }
      });
    });
  }

  window.openCartDrawer = () => {
    openCart(document.querySelector('#cart-icon-bubble'));
  };

  bindCartButtons();

  if (openNavBtn) {
    openNavBtn.addEventListener('click', () => {
      if (!navContainer) return;
      navContainer.classList.add('open');
      document.body.classList.add('no-scroll');
      document.body.style.overflow = 'hidden';

      const utilityBar = document.querySelector('.utility-bar');
      if (utilityBar) utilityBar.style.display = 'none';
    });
  }

  if (closeNavBtn) {
    closeNavBtn.addEventListener('click', () => {
      if (!navContainer) return;
      navContainer.classList.remove('open');
      unlockBodyScrollIfNothingOpen();

      const utilityBar = document.querySelector('.utility-bar');
      if (utilityBar) utilityBar.style.display = 'block';
    });
  }

  document.querySelectorAll('.nav-drawer__toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('aria-controls');
      const target = document.getElementById(id);
      const open = btn.getAttribute('aria-expanded') === 'true';

      btn.setAttribute('aria-expanded', String(!open));

      if (open) {
        if (target) target.setAttribute('hidden', '');
        btn.textContent = '+';
      } else {
        if (target) target.removeAttribute('hidden');
        btn.textContent = '–';
      }
    });
  });

  document.addEventListener('click', (e) => {
    const isMiniClose = e.target.classList && e.target.classList.contains('nav-drawer__mini-close');
    if (!isMiniClose) return;

    if (navContainer) navContainer.classList.remove('open');
    unlockBodyScrollIfNothingOpen();

    const utilityBar = document.querySelector('.utility-bar');
    if (utilityBar) utilityBar.style.display = 'block';
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    if (navContainer && navContainer.classList.contains('open')) {
      navContainer.classList.remove('open');
      const utilityBar = document.querySelector('.utility-bar');
      if (utilityBar) utilityBar.style.display = 'block';
    }

    unlockBodyScrollIfNothingOpen();
  });
});
